<style scoped lang="scss" type="text/scss">
    .status {
        font-size: .75rem;

        &.not-open {
            color: #AAA;
        }

        &.closed, &.finished {
            color: #FF3333;
        }

        &.registrable {
            color: #3faa8e;
        }
    }
</style>

<template>
    <span class="status"
          :class="{'closed': 'closed' === statusLEDClass, 'not-open': 'not-open' === statusLEDClass, 'registrable': 'registrable' === statusLEDClass,  'finished': 'finished' === statusLEDClass}">
        <i class="icon">&#xe614;</i>
        <span>{{ statusText }}</span>
    </span>
</template>

<script>
    export default {
        name: '',
        props: {
            status: {
                type: String,
                default: ''
            }
        },
        data () {
            return {
                statusLEDClass: null,
                statusText: null
            };
        },
        watch: {
            status: {
                immediate: true,
                handler (status) {
                    if ('closed' === status) {
                        this.statusLEDClass = 'closed';
                        this.statusText = '报名截止';
                    } else if ('not-open' === status) {
                        this.statusLEDClass = 'not-open';
                        this.statusText = '未开放报名';
                    } else if ('registrable' === status) {
                        this.statusLEDClass = 'registrable';
                        this.statusText = '正在报名';
                    } else if ('finished' === status) {
                        this.statusLEDClass = 'finished';
                        this.statusText = '比赛结束';
                    }
                }
            }
        }
    };
</script>
